import { apiSlice } from "../../api/ApiService";
import { getHeadersFromRedux } from "../../utility/functions/common-functions";

const getPatientActiveLanguageApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPatientActiveLanguage: builder.query({
      query: () => {
        const headers = getHeadersFromRedux();
        return {
          url: `/api/v1/Patient/supported-languages`,
          method: "GET",
          headers,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetPatientActiveLanguageQuery } = getPatientActiveLanguageApi;
export default getPatientActiveLanguageApi;
